module.exports = __webpack_public_path__ + "img/lootboxpost.71266970.png";